import store from '@state/store'
import roles from '@constants/userroles'

export default function accesslevels(levels) {
  let roleObj = Object(store.getters['auth/userInfo'].roles)
  let accessBlocks = defineAccessLevels()
  let rollaccess = false

  for (let property in roleObj) {
    let currentRole = String(roleObj[property]).toLocaleLowerCase()
    rollaccess = accessBlocks[levels].indexOf(currentRole)
    if (rollaccess !== -1) break
  }

  return rollaccess >= 0

  // let currentRole = String(
  //   store.getters['auth/userInfo'].role
  // ).toLocaleLowerCase()

  // console.log('store obj = ', Object(store.getters['auth/userInfo'].roles))
  // console.log('accessBlocks = ', accessBlocks[levels])
}

function defineAccessLevels() {
  let cpm = String(roles.xactusAdmin).toLocaleLowerCase()
  let cpp = String(roles.xactusProcessor).toLocaleLowerCase()
  let cpu = String(roles.xactusUser).toLocaleLowerCase()
  let custadm = String(roles.customerAdmin).toLocaleLowerCase()
  let custpro = String(roles.CreditManagerOrProcessor).toLocaleLowerCase()
  let custreq = String(roles.CreditAnalystOrLoanOfficer).toLocaleLowerCase()
  let fadm = String(roles.FAMMAdmin).toLocaleLowerCase()
  let fusr = String(roles.FAMMUser).toLocaleLowerCase()
  let preqadm = String(roles.prequalAdmin).toLocaleLowerCase()
  let supadm = String(roles.superAdmin).toLocaleLowerCase()
  let cpexe = String(roles.xactusExecutive).toLocaleLowerCase()
  let loanoff = String(roles.loanOfficer).toLocaleLowerCase()
  let fraudAdm = String(roles.fraudPlusAdmin).toLocaleLowerCase()
  let xse = String(roles.xactusSalesExecutive).toLocaleLowerCase()
  let xf = String(roles.xactusFinance).toLocaleLowerCase()
  let xc = String(roles.xactusCompliance).toLocaleLowerCase()

  let accessBlocks = []
  accessBlocks[0] = cpm
  accessBlocks[1] = [cpm, cpp]
  accessBlocks[2] = [cpm, custadm]
  accessBlocks[3] = [cpm, custadm, cpp]
  accessBlocks[4] = [cpm, cpp, custadm, custpro]
  accessBlocks[5] = [cpm, cpp, custadm, custpro, custreq]

  accessBlocks[6] = [cpp]
  accessBlocks[7] = [custadm]
  accessBlocks[8] = [custpro]
  accessBlocks[9] = [custreq]

  accessBlocks[10] = [fadm]
  accessBlocks[11] = [fusr]
  accessBlocks[12] = [fadm, fusr]
  accessBlocks[13] = [preqadm]
  accessBlocks[14] = [supadm]
  accessBlocks[15] = [cpexe]
  accessBlocks[16] = [loanoff]
  accessBlocks[17] = [cpm, custadm, preqadm, supadm, cpexe]
  accessBlocks[18] = [cpm, preqadm, supadm, cpexe, loanoff, custadm]
  accessBlocks[19] = [cpm, custadm, cpu, loanoff]
  accessBlocks[20] = [cpm, supadm, preqadm]
  accessBlocks[21] = [cpm, cpp, cpexe, supadm, preqadm, fraudAdm]
  accessBlocks[22] = [loanoff, cpexe]

  accessBlocks[23] = [custadm, custpro, custreq]
  accessBlocks[24] = [
    cpm,
    cpp,
    custadm,
    custpro,
    custreq,
    preqadm,
    supadm,
    cpexe,
    loanoff,
    fraudAdm,
  ]
  accessBlocks[25] = [custadm, custpro, custreq, loanoff]
  accessBlocks[26] = [fraudAdm]
  accessBlocks[27] = [cpm, cpexe]
  accessBlocks[28] = [cpm, cpp, preqadm, supadm, cpexe, fraudAdm, fadm]
  accessBlocks[29] = [xse]
  accessBlocks[30] = [xf]
  accessBlocks[31] = [xc]
  return accessBlocks
}

/** declare constants to be used as shorthand for all roles */
// sphere roles
const xa = 'xa'
const xp = 'xp'
const fpa = 'fpa'
const fma = 'fma'
const fmu = 'fmu'
const ca = 'ca'
const cp = 'cp'
const cr = 'cr'
const lo = 'lo'
const xse = 'xse'
const xfu = 'xfu'
const xe = 'xe'
const xf = 'xf'
const xc = 'xc'

// hmda roles
const xha = 'xha'
const xhm = 'xhm'
const xhp = 'xhp'
const lha = 'lha'
const lhm = 'lhm'
const lhp = 'lhp'

const sphere = [xp, fpa, ca, cp, cr, lo, xse, xfu, fma, fmu, xe, xf, xc]
const hmdaUsers = [xa, xha, xhm, xhp, lha, lhm, lhp]

/** All roles in the application mapped to their shorthand notation */
const allRoles = [
  { title: 'XA', role: roles.xactusAdmin.toLowerCase() },
  { title: 'XP', role: roles.xactusProcessor.toLowerCase() },
  { title: 'FPA', role: roles.fraudPlusAdmin.toLowerCase() },
  { title: 'FMA', role: roles.FAMMAdmin.toLowerCase() },
  { title: 'FMU', role: roles.FAMMUser.toLowerCase() },
  { title: 'CA', role: roles.customerAdmin.toLowerCase() },
  { title: 'CR', role: roles.CreditAnalystOrLoanOfficer.toLowerCase() },
  { title: 'CP', role: roles.CreditManagerOrProcessor.toLowerCase() },
  { title: 'LO', role: roles.loanOfficer.toLowerCase() },
  { title: 'XSE', role: roles.xactusSalesExecutive.toLowerCase() },
  { title: 'XFU', role: roles.xactusFinanceUser.toLowerCase() },
  { title: 'XE', role: roles.xactusExecutive.toLowerCase() },
  { title: 'XF', role: roles.xactusFinance.toLowerCase() },
  { title: 'XC', role: roles.xactusCompliance.toLowerCase() },

  { title: 'XHA', role: roles.xactusHmdaAdmin.toLowerCase() },
  { title: 'XHM', role: roles.xactusHmdaManager.toLowerCase() },
  { title: 'XHP', role: roles.xactusHmdaProcessor.toLowerCase() },
  { title: 'LHA', role: roles.lenderHmdaAdmin.toLowerCase() },
  { title: 'LHM', role: roles.lenderHmdaManager.toLowerCase() },
  { title: 'LHP', role: roles.lenderHmdaProcessor.toLowerCase() },
]

const userManagementACL = {
  xa: [xa, xha, xhm, xhp, lha, lhm, lhp, ...sphere],
  xha: [xha, xhm, xhp, lha, lhm, lhp],
  lha: [lha, lhm, lhp],
  ca: [xa, ...sphere],
  xse: [xa, ...sphere],
  xc: [xa, ...sphere],
  // xe: [xa, ...sphere]
}

const assingUserRolesACL = {
  xa: [xa, xha, xhm, xhp, lha, lhm, lhp, ...sphere],
  xha: [xha, xhm, xhp, lha, lhm, lhp, ...sphere],
  lha: [lha, lhm, lhp, ...sphere],
  ca: [xa, ...sphere],
  xse: [xa, ...sphere],
  xc: [xa, ...sphere],
  // xe: [xa, ...sphere]
}

// const createHmdaProjectACL = [xa, xha, xhm, lha, lhm]
// const viewHmdaProjectSummaryACL = [xa, lha, lhm, lhp /** xha, xhm, xhp */]
// const viewHmdaProjectFilesACL = [xa, lha, lhm /** xha, xhm */]
// const viewHmdaProjectActivityACL = [xa, lha, lhm, lhp /** xha, xhm */]
// const canSelectCustomerACL = [xa, xha, xhm, xhp]

const createHmdaProjectACL = [xa, xha, xhm, lha, lhm]
const viewHmdaProjectSummaryACL = [xa, lha, lhm, lhp, xha, xhm, xhp]
const viewHmdaProjectFilesACL = [xa, xha, xhm, lha, lhm]
const viewHmdaProjectActivityACL = [xa, lha, lhm, lhp, xha, xhm, xhp]
const canSelectCustomerACL = [xa, xha, xhm, xhp]
const canAccessHMDASectionACL = [...hmdaUsers]
const canAddEditLeiACL = [xa, xha]
const canViewProjectsACL = [...hmdaUsers]
const canViewRulesACL = [...hmdaUsers]
const canRunRulesACL = [...hmdaUsers]
const larSummaryACL = [...hmdaUsers]
const canAccessAllHmdaCustomersACL = [xha, xhm, xhp]

/** logical implementation of roles and access lists */
const hmdaACLLogical = {
  validatePermissionRules: (targetRoles, myroles, rulesObject) => {
    let isManage = false
    myroles.some((mr) => {
      if (Array.isArray(rulesObject[mr])) {
        isManage = targetRoles.some((target) => {
          return rulesObject[mr].includes(target)
        })
        return isManage
      }
    })
    // console.log('As ', myroles, ' am i allowed to perform requested action ', targetRoles, ': ', isManage)
    return isManage
  },
  validateActionRule: (myroles, actionACL) => {
    let allowed = actionACL.some((action) => {
      return myroles.includes(action)
    })
    return allowed
  },
}

export const hmdaACL = {
  myRoles: [],
  userInfo: {},
  initializeAccessControls: () => {
    hmdaACL.userInfo = store.getters['auth/userInfo'] || {}
    const roles = hmdaACL.userInfo.roles || []
    hmdaACL.myRoles = hmdaACL.parseRoles(roles).targets
  },
  ___internalRoleParser: (roles) => {
    let parsed = []
    ;(roles || []).forEach((r) => {
      let b = allRoles.find((x) => x.role.toLowerCase() === r.toLowerCase())
      if (b) {
        parsed.push(b.title.toLowerCase())
      }
    })

    return parsed || []
  },

  parseRoles: (targetRoles, optMyRoles) => {
    // returns shorthand notation of all roles
    return {
      targets: (targetRoles || []).length
        ? hmdaACL.___internalRoleParser(targetRoles)
        : [],
      mine: optMyRoles
        ? hmdaACL.___internalRoleParser(optMyRoles)
        : hmdaACL.myRoles,
    }
  },

  isHMDAUser: (optMyRoles) => {
    let ab = hmdaACL.parseRoles([], optMyRoles)
    let isManage = ab.mine.some((mine) => {
      return hmdaUsers.includes(mine)
    })
    return isManage
  },

  // project details
  canViewHmdaProjectSummary: (optMyRoles) => {
    let ab = hmdaACL.parseRoles([], optMyRoles)
    return hmdaACLLogical.validateActionRule(ab.mine, viewHmdaProjectSummaryACL)
  },

  canViewHmdaProjectFiles: (optMyRoles) => {
    let ab = hmdaACL.parseRoles([], optMyRoles)
    return hmdaACLLogical.validateActionRule(ab.mine, viewHmdaProjectFilesACL)
  },

  canViewHmdaProjectActivity: (optMyRoles) => {
    let ab = hmdaACL.parseRoles([], optMyRoles)
    return hmdaACLLogical.validateActionRule(
      ab.mine,
      viewHmdaProjectActivityACL
    )
  },

  // create project
  canCreateHmdaProject: (optMyRoles) => {
    let ab = hmdaACL.parseRoles([], optMyRoles)
    return hmdaACLLogical.validateActionRule(ab.mine, createHmdaProjectACL)
  },

  canViewHmdaProject: (optMyRoles) => {
    let ab = hmdaACL.parseRoles([], optMyRoles)
    return hmdaACLLogical.validateActionRule(ab.mine, canViewProjectsACL)
  },

  // user management
  canManageOrAssignRoles: (targetRoles, optMyRoles) => {
    let ab = hmdaACL.parseRoles(targetRoles, optMyRoles)
    return (
      hmdaACLLogical.validatePermissionRules(
        ab.targets,
        ab.mine,
        userManagementACL
      ) ||
      hmdaACLLogical.validatePermissionRules(
        ab.targets,
        ab.mine,
        assingUserRolesACL
      )
    )
  },

  canAssignHmdaRoles: (targetRoles, optMyRoles) => {
    let ab = hmdaACL.parseRoles(targetRoles, optMyRoles)
    return hmdaACLLogical.validatePermissionRules(
      ab.targets,
      ab.mine,
      assingUserRolesACL
    )
  },

  canManageUser: (targetRoles, optMyRoles) => {
    let ab = hmdaACL.parseRoles(targetRoles, optMyRoles)
    return hmdaACLLogical.validatePermissionRules(
      ab.targets,
      ab.mine,
      userManagementACL
    )
  },
  canViewUsersList: () => {
    // replace this logic with 850 later when xactusHmdaAdmin is also allowed, for now limiting to lenderHmdaAdmin
    const user = store.getters['auth/userInfo'] || {}
    return (
      hmdaACL.parseRoles(user.roles).mine.includes('xha') ||
      hmdaACL.parseRoles(user.roles).mine.includes('lha')
    )
  },

  canSelectCustomer: (optMyRoles) => {
    let ab = hmdaACL.parseRoles([], optMyRoles)
    return hmdaACLLogical.validateActionRule(ab.mine, canSelectCustomerACL)
  },

  canAccessHMDASection: (optMyRoles) => {
    let ab = hmdaACL.parseRoles([], optMyRoles)
    return hmdaACLLogical.validateActionRule(ab.mine, canAccessHMDASectionACL)
  },

  canAddEditLei: (optMyRoles) => {
    let ab = hmdaACL.parseRoles([], optMyRoles)
    return hmdaACLLogical.validateActionRule(ab.mine, canAddEditLeiACL)
  },

  canViewRules: (optMyRoles) => {
    let ab = hmdaACL.parseRoles([], optMyRoles)
    return hmdaACLLogical.validateActionRule(ab.mine, canViewRulesACL)
  },

  canAccessLarSummary: (optMyRoles) => {
    let ab = hmdaACL.parseRoles([], optMyRoles)
    return hmdaACLLogical.validateActionRule(ab.mine, larSummaryACL)
  },

  canRunRules: (optMyRoles) => {
    let ab = hmdaACL.parseRoles([], optMyRoles)
    return hmdaACLLogical.validateActionRule(ab.mine, canRunRulesACL)
  },

  canAccessAllHmdaCustomers: (optMyRoles) => {
    let ab = hmdaACL.parseRoles([], optMyRoles)
    return hmdaACLLogical.validateActionRule(
      ab.mine,
      canAccessAllHmdaCustomersACL
    )
  },
}

export const hmdaLevels = {
  myAccLevel: -999,
  requiredLevelForTask: {
    createProject: 800,
    viewHmdaDashboard: 600,
    canSelectCustomer: 801,
    canViewProjects: 650,
    canViewRules: 650,
  },
  levels: [
    { val: 900, role: roles.xactusAdmin.toLowerCase() },

    { val: 850, role: roles.xactusHmdaAdmin.toLowerCase() },
    { val: 850, role: roles.lenderHmdaAdmin.toLowerCase() },

    { val: 800, role: roles.xactusHmdaManager.toLowerCase() },
    { val: 800, role: roles.lenderHmdaManager.toLowerCase() },

    { val: 650, role: roles.xactusHmdaProcessor.toLowerCase() },
    { val: 650, role: roles.lenderHmdaProcessor.toLowerCase() },
  ],
  initializeAccessControls: () => {
    const roles = store.getters['auth/userInfo'].roles || []
    hmdaLevels.myAccLevel = hmdaLevels.getMaxHmdaAccessLevel(roles)
  },
  getMaxHmdaAccessLevel: (roles) => {
    let lvl = 0
    roles.forEach((role) => {
      if (lvl < hmdaLevels.getRoleLevel(role))
        lvl = hmdaLevels.getRoleLevel(role)
    })
    return lvl
  },
  getRoleLevel: (role) => {
    role = role.toLowerCase().trim()
    return (
      (
        hmdaLevels.levels.find((x) => x.role.toLowerCase().trim() === role) ||
        {}
      ).val || 0
    )
  },
  canEditUser: (targetRoles) => {
    // check required to distinct HMDA-Sphere users/admins
    let isuserHmda = hmdaLevels.isHmdaUser()
    let isTargetHmda = hmdaLevels.isHmdaRange(
      hmdaLevels.getMaxHmdaAccessLevel(targetRoles)
    )
    if (isuserHmda || isTargetHmda) {
      // check if the target has higher role (here cpssadmin is an exception and he will be granted even if marked isHmdaUser=false)
      let anyRoleHigherOrEqual = (targetRoles || []).some(
        (role) => hmdaLevels.getRoleLevel(role) >= hmdaLevels.myAccLevel
      )

      let result = !anyRoleHigherOrEqual && isTargetHmda
      return result
    }
    return true
  },
  canViewHmdaDashboard: () =>
    hmdaLevels.myAccLevel >= hmdaLevels.requiredLevelForTask.viewHmdaDashboard,
  canCreateProject: () => {
    // return (
    //   hmdaLevels.myAccLevel >= hmdaLevels.requiredLevelForTask.createProject
    // )
    return true
  },
  canViewProjectList: () => true,
  canSelectCustomer: () =>
    hmdaLevels.myAccLevel >= hmdaLevels.requiredLevelForTask.canSelectCustomer,
  isHmdaUser: () => {
    if (hmdaLevels.myAccLevel === -999) {
      hmdaLevels.initializeAccessControls()
    }
    return hmdaLevels.isHmdaRange(hmdaLevels.myAccLevel)
  },
  isHmdaRange: (val) => {
    return val > 0 && val < 900
  },
  canEditUsersList: () => {
    // replace this logic with 850 later when xactusHmdaAdmin is also allowed, for now limiting to lenderHmdaAdmin
    const user = store.getters['auth/userInfo'] || {}
    return (
      user.roles.includes(roles.lenderHmdaAdmin) ||
      user.roles.includes(roles.xactusHmdaAdmin)
    )
  },

  canViewProjectsList: () => {
    // adjustment for sprint4 only
    let allowed = [
      roles.lenderHmdaAdmin.toLocaleLowerCase(),
      roles.lenderHmdaManager.toLocaleLowerCase(),
      roles.lenderHmdaProcessor.toLocaleLowerCase(),
      roles.xactusHmdaAdmin.toLocaleLowerCase(),
      roles.xactusHmdaManager.toLocaleLowerCase(),
      roles.xactusHmdaProcessor.toLocaleLowerCase(),
      roles.xactusAdmin.toLowerCase(),
    ]
    let access =
      hmdaLevels.myAccLevel >= hmdaLevels.requiredLevelForTask.canViewProjects
    if (access && allowed) {
      let yes = false
      const roles = store.getters['auth/userInfo'].roles || []
      roles.forEach((r) => {
        if (allowed.includes(r.toLocaleLowerCase())) {
          yes = true
        }
      })
      return yes
    }
    return false
    // adjustment ends here

    // use this after sprint4 stories are overwritten with additional roles, when roles are completed
    // return hmdaLevels.myAccLevel >= hmdaLevels.requiredLevelForTask.canViewProjects
  },

  canViewRulesList: () => {
    // adjustment for sprint4 only
    let allowed = [
      roles.lenderHmdaAdmin.toLocaleLowerCase(),
      roles.lenderHmdaManager.toLocaleLowerCase(),
      roles.lenderHmdaProcessor.toLocaleLowerCase(),
      roles.xactusHmdaAdmin.toLocaleLowerCase(),
      roles.xactusHmdaManager.toLocaleLowerCase(),
      roles.xactusHmdaProcessor.toLocaleLowerCase(),
      roles.xactusAdmin.toLowerCase(),
    ]
    let access =
      hmdaLevels.myAccLevel >= hmdaLevels.requiredLevelForTask.canViewProjects
    if (access && allowed) {
      let yes = false
      const roles = store.getters['auth/userInfo'].roles || []
      roles.forEach((r) => {
        if (allowed.includes(r.toLocaleLowerCase())) {
          yes = true
        }
      })
      return yes
    }
    return false
    // adjustment ends here

    // use this after sprint4 stories are overwritten with additional roles, when roles are completed
    // return hmdaLevels.myAccLevel >= hmdaLevels.requiredLevelForTask.canViewRules
  },
}
